module.exports = __webpack_public_path__ + "img/积分.6813859e.png";